import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Box, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useCustomDialogStyles from './useCustomDialogStyles';
import { between, colCenter } from '@ui/style/style';
const CustomDialog = ({ open, onClose, title, children, actions, titleIcon, maxWidth = 'sm', positionStatic = false, backgroundVariant = 'grey', titleWithIcon, closeIcon = false, backdropBlur = 0 }) => {
    const styles = useCustomDialogStyles(backgroundVariant);
    const theme = useTheme();
    return (_jsxs(Dialog, { open: open, scroll: 'body', onClose: onClose, disableAutoFocus: true, maxWidth: maxWidth, fullWidth: true, onClick: (e) => e.stopPropagation(), slotProps: {
            paper: {
                sx: {
                    ...styles.dialogContainer
                    // position: positionStatic ? 'static' : 'relative'
                }
            },
            backdrop: {
                sx: backdropBlur > 0
                    ? {
                        backdropFilter: `blur(${backdropBlur}px)`,
                        WebkitBackdropFilter: `blur(${backdropBlur}px)`
                    }
                    : undefined
            }
        }, children: [title && (_jsx(DialogTitle, { sx: { padding: '16px 24px 4px 24px' }, children: _jsxs(Box, { sx: between, children: [_jsx(Box, { sx: colCenter, gap: 1, children: _jsx(Typography, { variant: 'h6', children: title }) }), closeIcon && (_jsx(IconButton, { onClick: onClose, size: 'Xs', children: _jsx(CloseIcon, { style: { color: theme.palette.action.active } }) }))] }) })), titleWithIcon && (_jsx(DialogTitle, { sx: { padding: '16px 24px 4px 24px' }, children: _jsx(Box, { display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', children: _jsxs(Box, { sx: {
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                            width: '100%',
                            justifyContent: 'center'
                        }, gap: 0.5, children: [_jsx("img", { src: titleIcon, width: 60, height: 60, alt: 'Title Icon' }), _jsx(Typography, { variant: 'h6', children: titleWithIcon })] }) }) })), _jsx(DialogContent, { sx: { p: 0, maxHeight: 'calc(100dvh - 224px)', overflowY: 'auto' }, children: children }), actions && (_jsx(DialogActions, { sx: {
                    padding: 2,
                    '& > .MuiButton-root:last-of-type': {
                        color: theme.palette.common.white
                    }
                }, children: actions }))] }));
};
export default CustomDialog;
